// Copyright 2022-2023 @Polkasafe/polkaSafe-ui authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

import { ThemeConfig } from 'antd/es/config-provider/context';

// of the Apache-2.0 license. See the LICENSE file for details.
export const antdTheme: ThemeConfig = {
	hashed: false,
	token: {
		colorBgBase: '#1B2028',
		colorError: '#E63946',
		colorPrimary: '#1573FE',
		colorSuccess: '#06D6A0',
		colorTextPlaceholder: '#ffffff',
		colorWarning: '#FF9F1C',
		fontFamily: 'Archivo, sans-serif'
	}
};